import React from 'react';

export default function KeyStroke({ keystroke, color }) {
  const isColorWhite = `rgb(${color})` === 'rgb(255, 255, 255)';

  return (
    <div
      id={`exppanel-keystroke-${keystroke}-wrapper`}
      className={`font-bold text-[2rem] h-[60%] min-w-[100%] flex justify-center ${
        isColorWhite
          ? '[text-shadow:-1px_-1px_0_black,1px_-1px_0_black,-1px_1px_0_black,1px_1px_0_black]'
          : ''
      }`}
      style={{
        color: `rgb(${color})`,
      }}
    >
      {keystroke}
    </div>
  );
}
